import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { ApiService } from 'src/app/core/services/api.service';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-clone-trip-selector',
  templateUrl: './clone-trip-selector.component.html',
  styleUrls: ['./clone-trip-selector.component.scss']
})
export class CloneTripSelectorComponent {

  public _mFormGroup: FormGroup;
  public mToDate = new FormControl('');

  maxDate = new Date();
  minDate = new Date();

  constructor(
    private fb: FormBuilder,
    private readonly apiService: ApiService,
    private readonly ngxLoader: NgxUiLoaderService,
    private readonly notifyService: NotificationService,
    public dialogRef: MatDialogRef<CloneTripSelectorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    this._mFormGroup = this.fb.group({
      "toDate": this.mToDate
    });
    const parts = this.data.referenceDate.split('/');
    const day = Number(parts[0]);
    const month = Number(parts[1]) - 1;
    const year = Number(parts[2]);
    this.minDate = new Date(year, month, day);
    this.minDate.setDate(this.minDate.getDate() + 1);
    this.maxDate = new Date(year, month, day);
    this.maxDate.setDate(this.maxDate.getDate() + 14);
  }

  formatDate(d): any {
    let m = d.getMonth() + 1;
    let dt = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
    let mm = m < 10 ? "0" + m : m;
    return dt + "/" + mm + "/" + d.getFullYear();
  }

  onConfirmation() {
    if (!this.mToDate.value) return this.notifyService.showWarning("Please select ToDate", null);
    const reqBody = {
      ...this.data,
      "endDate": this.formatDate(this.mToDate.value)
    }

    this.ngxLoader.start();
    this.apiService.doPostRequestWithResponse(ApiConstants.cloneTripDates, reqBody, (success) => {
      if (success.status == 200) {
        this.ngxLoader.stop();
        this.dialogRef.close(success);
        this.notifyService.showSuccess(success.body.message, null);
      } else {
        this.ngxLoader.stop();
        this.notifyService.showWarning(success.body.message, null);
      }
    }, (error) => {
      this.ngxLoader.stop();
      this.notifyService.showError(error.message, null);
    });
  }
}
